import React from "react"
import { Layout } from "antd"
import Routes from "../../router"
import NotificationsController from "../helpers/NotificationsController"
import useSettings from "../../hooks/useSettings"

export default function Main() {
  const [settings] = useSettings()

  return (
    <NotificationsController>
      <Layout.Content
        className="site-layout-background"
        style={{ paddingBottom: settings.toolbar ? "35px" : 0 }}
      >
        <Routes />
      </Layout.Content>
    </NotificationsController>
  )
}
